import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { OtpInput } from '../OtpInput';
import { Button } from '../Button';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import { uiConfig } from '../../app-ui-config';
import styles from './OtpStep.css';

function getResendLabel(resendCountdown) {
    if (resendCountdown === 0) {
        return 'Get New Code';
    }

    if (resendCountdown >= 60) {
        return `Get New Code in ${Math.floor(resendCountdown / 60)} min ${resendCountdown % 60} sec`;
    }

    return `Get New Code in ${resendCountdown} sec`;
}

function OtpStep({ email, code, errors, isOtpPending, isPending, isResent, resendCountdown, otpCountdown, onComplete, onResend, onErrorClear }) {
    useEffect(() => {
        logEvent(EVENT_TYPES.SIGN_IN_OTP_VIEWED);
    }, []);

    return (
        <>
            <h1 className={styles.stepTitle}>Enter Your Sign-In Code</h1>
            <div className={styles.confirmWrapper}>
                <p className={styles.confirmText}>
                    We sent a sign-in code to <strong>{email}.</strong>
                </p>
                <p className={styles.confirmText}>
                    Look for the message titled <br /><strong>”Sign in to {uiConfig.domainTitle}”.</strong>
                </p>
                <p className={styles.confirmText}>
                    Can't find the email? Check your spam or junk folder
                </p>
            </div>
            <OtpInput
                onComplete={onComplete}
                onErrorClear={onErrorClear}
                errorText={otpCountdown > 0 ? `Too many attempts. Please wait ${otpCountdown} ${otpCountdown === 1 ? 'second' : 'seconds'} before trying again.` : errors.form}
                infoText={isResent ? 'New code sent. Use only the latest code — previous ones won\'t work.' : ''}
                value={code}
                isLoading={isOtpPending}
                isDisabled={otpCountdown > 0}
                isAutoFocus
            />
            <Button
                label={getResendLabel(resendCountdown)}
                onClick={onResend}
                className={styles.buttonResend}
                disabled={resendCountdown > 0 || otpCountdown > 0 || isOtpPending}
                isLoading={isPending}
                buttonProps={{ type: 'button' }}
            />
        </>
    );
}

OtpStep.propTypes = {
    email: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    errors: PropTypes.shape({ form: PropTypes.string }).isRequired,
    isOtpPending: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
    isResent: PropTypes.bool.isRequired,
    resendCountdown: PropTypes.number.isRequired,
    otpCountdown: PropTypes.number.isRequired,
    onComplete: PropTypes.func.isRequired,
    onResend: PropTypes.func.isRequired,
    onErrorClear: PropTypes.func.isRequired
};

export {
    OtpStep
};
